// extracted by mini-css-extract-plugin
export default {"root":"ProjectsCarousel-module--root--9f013","carousel":"ProjectsCarousel-module--carousel--b4a9f","slide":"ProjectsCarousel-module--slide--99035"};